<ng-container *ngIf="rebookingState$ | async as state">
    <h1 mat-dialog-title class="active">
        {{ "app.dialog.rebooking-history.title.header.label" | translate: {costCenter: data.costCenter.name, costType: data.costType.name} }}
    </h1>
    <div class="content" mat-dialog-content>

        <mat-tab-group (selectedTabChange)="onTabChange($event)">
            <mat-tab label="{{ 'app.dialog.rebooking-history.inflows.label' | translate }}"></mat-tab>
            <mat-tab label="{{ 'app.dialog.rebooking-history.outflows.label' | translate }}"></mat-tab>
        </mat-tab-group>

        <table mat-table [dataSource]="datasource">

            <ng-container matColumnDef="emittingCostCenter">
                <th mat-header-cell *matHeaderCellDef>
                    {{(tabIndex === 0 ? "app.dialog.rebooking-history.emittingCostCenter.label" : "app.dialog.rebooking-history.receivingCostCenter.label") | translate }}
                </th>
                <td mat-cell *matCellDef="let inflow">
                    <ng-container *ngIf="inflow.inflows.length > 0">
                        <button mat-icon-button
                                [style.visibility]="!inflow.expandable ? 'hidden' : ''"
                                [style.marginLeft.px]="inflow.level * 32"
                                (click)="treeControl.toggle(inflow)">
                            <mat-icon class="mat-icon-rtl-mirror">
                                {{treeControl.isExpanded(inflow) ? 'expand_more' : 'chevron_right'}}
                            </mat-icon>
                        </button>
                        <ng-container *ngIf="inflow.costApportionmentId !== undefined; else placeHolder">
                            {{state.distributionLookup[inflow.costApportionmentId].costCenter.name}}
                        </ng-container>
                    </ng-container>
                </td>
            </ng-container>

            <ng-container matColumnDef="emittingCostType">
                <th mat-header-cell
                    *matHeaderCellDef>{{(tabIndex === 0 ? "app.dialog.rebooking-history.emittingCostType.label" : "app.dialog.rebooking-history.receivingCostType.label") | translate }}</th>
                <td mat-cell *matCellDef="let inflow">
                    <ng-container *ngIf="inflow.inflows.length > 0">
                        <ng-container *ngIf="inflow.costApportionmentId !== undefined; else placeHolder">
                            {{state.distributionLookup[inflow.costApportionmentId].costType.name}}
                        </ng-container>
                    </ng-container>
                </td>
            </ng-container>

            <ng-template #placeHolder>-</ng-template>


            <ng-container matColumnDef="momentOfCalculation">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let inflow">
                    <ng-container *ngIf="inflow.inflows.length === 0">
                        {{inflow.momentOfCalculation | date: 'dd.MM.yyyy HH:mm:ss'}}
                    </ng-container>
                </td>
            </ng-container>

            <ng-container matColumnDef="valueCt">
                <th mat-header-cell *matHeaderCellDef>{{"app.dialog.rebooking-history.valueCt.label" | translate }}</th>
                <td mat-cell *matCellDef="let inflow">
                    <ng-container *ngIf="inflow.inflows.length > 0; else displayValueCt">
                        {{inflow.valueSumCt / 100 | currency:'EUR':'symbol':'1.2-2'}}
                    </ng-container>
                    <ng-template #displayValueCt>
                        {{inflow.valueCt / 100 | currency:'EUR':'symbol':'1.2-2'}}
                    </ng-template>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="layout.inflowColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: layout.inflowColumns;" [ngClass]="{'aggregateRow': row.inflows.length > 0}"></tr>
        </table>

    </div>
    <div mat-dialog-actions>
        <button mat-stroked-button mat-dialog-close (click)="close()">{{ "app.button.cancel.label" | translate }}</button>
    </div>
</ng-container>
